import { render, staticRenderFns } from "./ClientInvoiceSummary.vue?vue&type=template&id=e19e0bfa&scoped=true&"
import script from "./ClientInvoiceSummary.vue?vue&type=script&lang=ts&"
export * from "./ClientInvoiceSummary.vue?vue&type=script&lang=ts&"
import style0 from "./ClientInvoiceSummary.vue?vue&type=style&index=0&id=e19e0bfa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19e0bfa",
  null
  
)

export default component.exports